"use client";

import React, { useState } from "react";
import { ActionIcon, Button, Box, Popover } from "rizzui";
import { PiDotsThreeOutlineVerticalFill, PiCheck, PiX } from "react-icons/pi";

export function MoreActionsNameChange({
  id,
  onApprove,
  onDeny,
}: {
  id: string;
  onApprove: () => void;
  onDeny: () => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Popover placement="bottom-end">
      <Popover.Trigger>
        <ActionIcon title="Actions" variant="text">
          <PiDotsThreeOutlineVerticalFill className="h-5 w-5 text-gray-600" />
        </ActionIcon>
      </Popover.Trigger>
      <Popover.Content className="w-[140px] p-2 bg-white shadow rounded">
        {({ setOpen: closePopover }) => (
          <Box>
            <Button
              variant="text"
              className="w-full justify-start px-2 py-1 text-green-600"
              onClick={() => {
                console.log(`Approving request ${id}`);
                onApprove();
                closePopover(false);
              }}
            >
              <PiCheck className="mr-2" /> Approve
            </Button>
            <Button
              variant="text"
              className="w-full justify-start px-2 py-1 text-red-600"
              onClick={() => {
                console.log(`Denying request ${id}`);
                onDeny();
                closePopover(false);
              }}
            >
              <PiX className="mr-2" /> Deny
            </Button>
          </Box>
        )}
      </Popover.Content>
    </Popover>
  );
}
